module.exports = __webpack_public_path__ + "static/media/lk.4149bab4.webp";